import ngRedux from 'ng-redux';
import store from './store';

export default angular.module('mcp.admin.core.store', [ngRedux]).config([
  '$ngReduxProvider',
  ($ngReduxProvider) => {
    $ngReduxProvider.provideStore(store);
  },
]);
